import React from "react";
import { Row } from "antd";
import { useParams } from "react-router-dom";
import OwlCarousel from "react-owl-carousel";

import useMapData from "../../utils/useMapData";
import useWindowDimensions from "../../utils/useWindowDimensions";

import MapItems from "./MapItems";

import "./OwnCarousel.scss";

const OwlCarouselCmp = () => {
  const { propertyId } = useParams();
  const resultList = useMapData(propertyId);

  const { width } = useWindowDimensions();

  const isWideScreen = width > 768;

  const options = {
    rewind: true,
    loop: false,
    margin: 10,
    items: isWideScreen ? 3 : 2,
    autoplay: true,
  };

  // console.log(resultList);

  if (resultList.length === 0) {
    return null;
  }

  const extractAmenitiesRowOne =
    resultList.amenities &&
    resultList.amenities?.slice(0, 4).filter(i => i.checked);

  const extractAmenitiesRowTwo =
    resultList.amenities &&
    resultList.amenities?.slice(4, 8).filter(i => i.checked);

  const extractAmenitiesRowThree = resultList.amenities
    .slice(8, resultList.amenities.length)
    .filter(i => i.checked);

  return (
    <Row className="features">
      <OwlCarousel className="owl-theme" {...options}>
        {extractAmenitiesRowOne.map(item => {
          return <MapItems key={`${item.title}`} item={item} />;
        })}
      </OwlCarousel>
      <OwlCarousel className="owl-theme" {...options}>
        {extractAmenitiesRowTwo.map(item => {
          return <MapItems key={`${item.id}+${item.title}`} item={item} />;
        })}
      </OwlCarousel>
      <OwlCarousel className="owl-theme" {...options}>
        {extractAmenitiesRowThree.map(item => {
          return <MapItems key={`${item.id}+${item.title}`} item={item} />;
        })}
      </OwlCarousel>
    </Row>
  );
};
export default OwlCarouselCmp;
